export default __webpack_public_path__ + "static/Vetcor-1f98b5188964db85e85a9b91246d534a.png";